import style from './Footer.module.less';

interface FooterProps {
  className?: string;
}
const Footer: React.FC<FooterProps> = props => {
  return (
    <div className={`${style.wrapper} ${props.className}`}>
      <span>
        © 2015-2022 江苏优美数科技有限公司 版权所有
      </span>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32028102001167" target="__blank">苏公网安备32028102001167</a>
      <a href="https://beian.miit.gov.cn/" target="__blank">苏ICP备2021046523号-3</a>
    </div>
  );
};

export default Footer;